import Mp3Encoder from './mp3-encoder';
import { convertTimeMMSS } from './utils';

export default class {
  constructor (options = {}) {
    this.beforeRecording = options.beforeRecording;
    this.pauseRecording = options.pauseRecording;
    this.afterRecording = options.afterRecording;
    this.micFailed = options.micFailed;
    this.format = options.format;

    this.encoderOptions = {
      bitRate: 16,
      sampleRate: 16000
    };

    this.records = [];

    this.isPause = false;
    this.isRecording = false;

    this.duration = 0;
    this._duration = 0;
    this.volume = 0;

    this.durationInterval = null;

    window.addEventListener('audioinputerror', this._micError, false);
    window.addEventListener('audioinput', (evt) => {
      this._micInput(evt);
    }, false);
  }

  async start () {
    this.beforeRecording && this.beforeRecording('start recording');

    // Check permissions
    await new Promise((resolve, reject) => {
      window.audioinput.checkMicrophonePermission(function (hasPermission) {
        if (hasPermission) {
          resolve();
        } else {
          // Ask the user for permission to access the microphone
          window.audioinput.getMicrophonePermission(function (hasPermission, message) {
            if (hasPermission) {
              resolve();
            } else {
              reject('Permissions denied' + message);
            }
          });
        }
      });
    });

    this.totalReceivedData = null;
    this.lastTimestamp = null;
    this.durationInterval = this._createStatusTimer();
    window.audioinput.start({
      format: window.audioinput.FORMAT.PCM_16BIT,
      channels: 1,
      sampleRate: 16000
    });

    this.isPause = false;
    this.isRecording = true;

    if (!this.lameEncoder) {
      this.lameEncoder = new Mp3Encoder(this.encoderOptions);
    }
  }

  async stop () {
    await new Promise((resolve) => {
      window.audioinput.stop(() => {
        const record = this.lameEncoder.finish();
        record._duration = convertTimeMMSS(this._duration);

        this.records.push(record);

        this._duration = 0;
        this.duration = 0;
        clearInterval(this.durationInterval);

        this.isPause = false;
        this.isRecording = false;

        this.afterRecording && this.afterRecording(record);
        resolve();
      });
    });
  }

  pause () {
    window.audioinput.stop(() => {
      this.isPause = true;
      clearInterval(this.durationInterval);
    });

    this.pauseRecording && this.pauseRecording('pause recording');
  }

  lastRecord () {
    return this.records.slice(-1).pop();
  }

  _micInput (evt) {
    try {
      if (evt && evt.data) {
        const sample = evt.data;
        let sum = 0.0;

        if (!this.lastTimestamp) {
          this._duration = 0;
          this.lastTimestamp = evt.timeStamp;
        } else {
          this._duration = this._duration + ((evt.timeStamp - this.lastTimestamp) / 1000);
          this.lastTimestamp = evt.timeStamp;
        }
        this.volume = Math.sqrt(sum / sample.length).toFixed(2);

        this.lameEncoder.encode(sample);

        for (let i = 0; i < sample.length; ++i) {
          sum += sample[i] * sample[i];
        }
      } else {
        alert('Unknown audioinput event: ' + JSON.stringify(evt));
      }
    } catch (ex) {
      alert('onAudioInputCapture ex: ' + ex);
    }
  }

  _micError (error) {
    console.error(error);
    this.micFailed && this.micFailed(error);
  }

  _createStatusTimer () {
    return setInterval(() => {
      this.duration += 1;
    }, 1000);
  }
}
